import { useEffect } from "react";

import { Button } from "@/components/ui/button";

interface ConfirmLogoutDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmLogoutDialog({
  open,
  onCancel,
  onConfirm,
}: ConfirmLogoutDialogProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center px-4"
      onClick={onCancel}
    >
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        aria-hidden
      />

      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-logout-title"
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-sm rounded-xl border border-border bg-surface p-6 shadow-2xl animate-fade-in"
      >
        <h2
          id="confirm-logout-title"
          className="text-lg font-semibold text-foreground"
        >
          ¿Cerrar sesión?
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
          Para volver a entrar necesitarás un nuevo link enviado a tu correo.
        </p>

        <div className="mt-6 flex justify-end gap-2">
          <Button variant="secondary" onClick={onCancel} autoFocus>
            Cancelar
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Cerrar sesión
          </Button>
        </div>
      </div>
    </div>
  );
}
